<template>
  <div>
    <div v-show="effortEmployeeProject.length > 0">
      <div class="calender-search d-flex justify-content-between">
        <div>
          Tổng cost hiện tại của toàn dự án: <span class="total-real-cost">{{ project.real_cost }}MM</span>
        </div>
        <DatePicker
          v-model="currentDate"
          @change="getDaysBelongPeriod(2)"
          range
          :clearable="false"
          format="DD/MM/YYYY"
        />
      </div>
      <div id="wrapper-calender">
        <div class="tableFixHead" id="table-calender" ref="tableCalender">
          <table>
            <tbody>
              <tr class="head-row">
                <th class="endcol">{{ $t("project_management.effort.overview.total_cost") }}</th>
                <td v-for="(day, index) in days" v-bind:key="index">
                  {{ day.dateFormat }}
                </td>
                <td
                  :rowspan="effortEmployeeProject.length + 1"
                  v-if="!disable && days.length > 0"
                >
                  <scroll-loader
                    :loader-method="getDate"
                    :loader-disable="disable"
                  >
                  </scroll-loader>
                </td>
                <th class="second-column">{{ $t("project_management.effort.overview.name") }}</th>
                <th class="first-column">No</th>
              </tr>
              <tr
                v-for="(employee, index) in effortEmployeeProject"
                v-bind:key="index"
              >
                <th class="endcol">
                  {{ employee.total_effort ? employee.total_effort : 0 }}MD
                </th>
                <td
                  v-for="(day, index) in days"
                  v-bind:key="index"
                  class="column-effort"
                  :class="[
                    day.day === 0 || day.day === 6 ? 'holiday' : '',
                    effortEmployeeProjectDetail[employee.project_employee_id + '-' + day.date] !== undefined ? '' : 'no-data',
                    checkDateBelongProject(employee.date_range, day.date) ? '': 'not-belong-date'
                  ]"
                  @click="$emit('edit-effort', day.date, checkDateBelongProject(employee.date_range, day.date))"
                >
                  {{
                    effortEmployeeProjectDetail[
                      employee.project_employee_id + "-" + day.date
                    ]
                  }}
                </td>
                <th class="second-column">{{ employee.name }}</th>
                <th class="first-column">{{ index + 1 }}</th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="wrapper-no-data" v-show="effortEmployeeProject.length === 0">
      <h3>Không có dữ liệu</h3>
    </div>
	</div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { mapGetters } from "vuex";
const TYPE_DEFAULT = 1;
export default {
	components: {
		DatePicker
	},
	data() {
		return {
			days: [],
      disable: false,
      currentDate: [new Date(moment().subtract(1, 'months')), new Date()],
		}
	},
  computed: {
    ...mapGetters({
      project: "project/project",
      effortEmployeeProject: "projectManagement/effortEmployeeProject",
      effortEmployeeProjectDetail: "projectManagement/effortEmployeeProjectDetail",
    }),
	},
  watch: {
    currentDate(newValue,oldValue) {
      if (moment(this.currentDate[0]).isSame(moment(this.currentDate[1]))) {
        this.$toast(
          this.$t("project_management.effort.overview.select_date_error"),
          "Error",
          1000,
          "b-toaster-top-center",
          "danger"
        );
        this.currentDate = oldValue;
        this.getDaysBelongPeriod(2)
      }
    }
  },
	created() {
		this.getDaysBelongPeriod(TYPE_DEFAULT);
    this.$store.dispatch("project/getInfoProject", this.$route.params.id)
    this.$store.dispatch("projectManagement/getEffortEmployeeProject", this.$route.params.id);
	},
	mounted() {
    document.getElementById('table-calender').addEventListener('wheel', function(e){
      e.preventDefault();
      document.getElementById('table-calender').scrollLeft = document.getElementById('table-calender').scrollLeft + e.deltaY;
    });
  },
  beforeDestroy() {
    this.$store.commit("projectManagement/SET_EFFORT_EMPLOYEE_PROJECT_DETAIL", {});
  },
	methods: {
    checkDateBelongProject(dateRanges, dateCheck) {
      if (!dateRanges) {
        return false;
      }
      
      for (let dateRange of dateRanges) {
        if (moment(dateCheck, "YYYY-MM-DD").isSameOrAfter(dateRange[0]) && moment(dateCheck, "YYYY-MM-DD").isSameOrBefore(dateRange[1])) {
          return true;
        }
      }

      return false;
    },
		getDate() {
      this.getDaysBelongPeriod(TYPE_DEFAULT, moment(this.days[this.days.length-1].date).subtract(1, 'days'));
    },
    getDaysBelongPeriod(type, time = null) {
      let startDate = null;
      let endDate = null;
      if (type === TYPE_DEFAULT) {
        if (!time) {
          endDate = moment();
          startDate = moment().subtract(1, 'months');
        } else {
          endDate = moment(time);
          startDate = moment(time).subtract(1, 'months');
        }
        this.getEffortEmployeeProjectDetail(startDate, endDate, true);
      } else {
        startDate = moment(this.currentDate[0]);
        endDate = moment(this.currentDate[1]);
        this.days = [];
        document.getElementById('table-calender').scrollLeft = 0;
        this.getEffortEmployeeProjectDetail(startDate, endDate);
      }

      while (endDate > startDate) {
        this.days.push({
          day: endDate.day(),
          date: moment(endDate).format('YYYY-MM-DD'),
          dateFormat: moment(endDate).format('DD/MM')
        });
        endDate.subtract(1, 'days');
      }
    },
    getEffortEmployeeProjectDetail(startDate, endDate, isPushData = false) {
      this.$store.dispatch("projectManagement/getEffortEmployeeProjectDetail", {
        id: this.$route.params.id,
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
        isPushData: isPushData
      });
    },
	}
}
</script>

<style lang="scss" scoped>
  #wrapper-calender {
    display: flex;
    justify-content: center;
    padding: 10px 30px;
  }

  .tableFixHead {
    overflow: auto;
    direction:rtl;
    width: 100%;
    text-align: center;
    border-radius: 10px;
    scrollbar-width: none;
    table {
      border-collapse: separate;
      border-spacing: 0;
      td, th {
        font-weight: normal;
        color: #303C54;
      }
      .no-data {
        background: #FFDCDC;
      }
      .not-belong-date {
        background: #009999;
      }
      .holiday {
        background: #CED2D8;
        border: 1px solid #EFEFEF;
      }
      .head-row {
        td, th {
          background: #3488EB;
          color: #FFFFFF;
        }
      }
    }
  }

  .tableFixHead {
    tbody {
      th {
        position: sticky;
      }
      .first-column {
        left: 0;
        max-width: 60px;
      }
      .second-column {
        left: 52px;
        border-left: none;
      }
    }
  }

  .endcol {
    position: absolute;
    right: 0px;
    font-weight: normal;
  }

  th, td {
    padding: 10px 16px;
    white-space: nowrap;
    border: 1px solid #CED2D8;
  }
  th {
    background: #FFFFFF;
  }

  #table-calender::-webkit-scrollbar {
    /* This is the magic bit for WebKit */
    display: none;
  }

  .calender-search {
    padding: 0px 30px;
    div:first-child {
      color: #303C54;
    }
    .total-real-cost {
      font-size: 18px;
      color: #17A896;
    }
  }

	.column-effort {
		cursor: pointer;
	}

  .wrapper-no-data {
    padding: 30px;
    h3 {
      font-size: 20px;
      text-align: center;
    }
  }

  /deep/ .mx-datepicker {
    width: 260px !important;
  }

</style>
